import React from "react";
import "../assets/styles/Politica.css";

const PrivacyContent = () => {
  return (
    <>
      <div className="py-5">
        <p>
          A Puríssima se dedica a oferecer suplementos e orientações
          personalizadas por meio de um questionário de saúde e estilo de
          vida e, para isso, necessita processar determinadas informações
          de forma transparente e segura.
        </p>
        <p>
          Elaboramos esta Política de Privacidade para que você, usuário,
          compreenda detalhadamente como coletamos, utilizamos,
          armazenamos, compartilhamos e protegemos seus dados pessoais,
          bem como os fundamentos legais e as medidas de segurança
          adotadas para assegurar a sua integridade.
        </p>
      </div>

      <article>
        <h3>1. Conceitos e Termos Fundamentais</h3>
        <p>
          Para facilitar a compreensão deste documento, apresentamos
          abaixo os termos e definições que serão utilizados ao longo
          desta Política:
        </p>
        <ul>
          <li><strong>Usuário:</strong> Pessoa natural ou jurídica que acessa o site ou utiliza os serviços oferecidos pela Puríssima.</li>
          <li><strong>Cliente:</strong> Pessoa física que adquire produtos ou serviços no site da Puríssima, podendo ser também um usuário que preenche o questionário de saúde.</li>
          <li><strong>Política de Privacidade:</strong> Este documento, que detalha as práticas da Puríssima relativas ao tratamento de dados pessoais, em conformidade com a LGPD.</li>
          <li><strong>LGPD:</strong> Lei Geral de Proteção de Dados – Lei nº 13.709/18, que regula o tratamento de dados pessoais no Brasil.</li>
          <li><strong>Dados Pessoais:</strong> Qualquer informação relacionada a uma pessoa natural identificada ou identificável, tais como nome, e-mail, telefone, CPF, endereço, entre outros.</li>
          <li><strong>Dados Pessoais Sensíveis:</strong> Dados relacionados à saúde, como informações sobre condições médicas, alergias e uso de medicamentos ou suplementos, fornecidos por meio do nosso questionário.</li>
          <li><strong>Titular:</strong> A pessoa natural a quem se referem os dados pessoais objeto deste tratamento.</li>
          <li><strong>Tratamento de Dados Pessoais:</strong> Toda operação realizada com dados pessoais, como coleta, armazenamento, uso, transmissão, exclusão, entre outras atividades.</li>
          <li><strong>Controlador:</strong> Pessoa física ou jurídica que toma as decisões referentes ao tratamento dos seus dados pessoais, neste caso, a Puríssima.</li>
          <li><strong>Operador:</strong> Pessoa ou empresa que realiza o tratamento dos dados pessoais em nome da Puríssima, seguindo as suas orientações.</li>
          <li><strong>Registros de Acesso:</strong> Conjunto de informações relativas à data, hora e endereço IP de acesso ao site.</li>
          <li><strong>Finalidade:</strong> O propósito específico para o qual os dados pessoais são coletados e tratados, conforme descrito neste documento.</li>
          <li><strong>Consentimento:</strong> Autorização livre, informada e inequívoca por parte do Titular, mediante a qual este concorda com o tratamento de seus dados pessoais para finalidades previamente estipuladas. A revogação do consentimento não afeta os tratamentos realizados anteriormente.</li>
        </ul>
      </article>

      <article>
        <h3>2. Finalidades e Abrangência do Tratamento de Dados</h3>
        <p>
          A Puríssima utiliza seus dados pessoais e dados sensíveis para
          proporcionar um atendimento único, personalizado e seguro, que
          engloba diversas atividades essenciais à operação dos nossos
          serviços. De forma detalhada, explicamos a seguir as finalidades
          para as quais os seus dados são coletados e tratados:
        </p>

        <h4>2.1. Personalização e Recomendações de Suplementos</h4>
        <p>
          Para oferecer um atendimento de excelência e personalizado,
          coletamos informações fornecidas através de questionários de
          saúde e estilo de vida. Com esses dados, nossa inteligência
          interna avalia seu perfil e recomenda suplementos que melhor
          atendam às suas necessidades individuais, visando a otimização
          do seu bem-estar.
        </p>

        <h4>2.2. Processamento de Pedidos e Prestação de Serviços</h4>
        <p>
          Seus dados são utilizados para processar os pedidos realizados,
          possibilitar a manipulação dos suplementos na farmácia e
          assegurar a entrega correta e segura dos produtos. Este
          tratamento também envolve a gestão de informações relacionadas à
          logística e ao acompanhamento dos pedidos.
        </p>

        <h4>2.3. Comunicação, Suporte e Acompanhamento</h4>
        <p>
          A Puríssima mantém canais de comunicação, como chat no site,
          WhatsApp e e-mail, para oferecer suporte, esclarecimentos e
          acompanhamento contínuo do seu tratamento. Este canal de
          atendimento visa facilitar o acesso às informações, resolver
          dúvidas e garantir que você se sinta amparado durante todo o
          processo.
        </p>

        <h4>2.4. Marketing, Pesquisa e Melhoria de Serviços</h4>
        <p>
          Utilizamos seus dados para enviar comunicações de marketing,
          novidades, promoções e conteúdos educativos, sempre com o seu
          consentimento. Além disso, realizamos pesquisas de satisfação e
          análises de uso, que nos ajudam a aprimorar nossos produtos e
          serviços, garantindo que atendamos às suas expectativas e
          necessidades de forma cada vez mais eficaz.
        </p>

        <h4>2.5. Cumprimento de Obrigações Legais e Regulatórias</h4>
        <p>
          Em determinadas situações, o tratamento de dados pessoais é
          necessário para cumprir obrigações legais, regulamentares ou
          para responder a solicitações de autoridades competentes, sempre
          respeitando os limites impostos pela legislação vigente.
        </p>

        <p>
          <strong>Observação:</strong> A Puríssima utiliza seus dados
          unicamente para as finalidades descritas, jamais realizando
          qualquer tratamento que não esteja previamente autorizado por
          você ou previsto na legislação.
        </p>
      </article>

      <article>
        <h3>3. Dados que Coletamos</h3>
        <p>
          A coleta de informações pela Puríssima é realizada de forma
          transparente e consensual, garantindo que você esteja sempre
          ciente dos dados fornecidos e de como eles serão utilizados. A
          seguir, detalhamos os tipos de dados que podem ser coletados:
        </p>

        <h4>3.1. Dados Pessoais Básicos e de Cadastro</h4>
        <p>Ao se cadastrar em nosso site, você nos fornece dados essenciais para a identificação e contato...</p>
        <ul>
          <li>Nome completo;</li>
          <li>Endereço de e-mail;</li>
          <li>Número de telefone;</li>
          <li>CPF;</li>
          <li>Endereço residencial ou comercial;</li>
          <li>Outros dados de identificação pessoal que venham a ser incluídos futuramente.</li>
        </ul>

        <h4>3.2. Dados Relacionados à Saúde e Perfil Pessoal</h4>
        <p>Para oferecer recomendações de suplementos e orientações de forma personalizada, coletamos informações sobre:</p>
        <ul>
          <li>Histórico de condições médicas e doenças pré-existentes;</li>
          <li>Alergias e sensibilidades a medicamentos ou substâncias;</li>
          <li>Uso atual de medicamentos e/ou suplementos;</li>
          <li>Respostas fornecidas nos questionários de saúde, que avaliam sintomas, estilo de vida e hábitos alimentares;</li>
          <li>Qualquer outra informação que possa contribuir para a personalização do atendimento, conforme for necessário.</li>
        </ul>

        <h4>3.3. Dados de Navegação e Informações Técnicas</h4>
        <p>Durante a sua navegação em nosso site, coletamos automaticamente dados técnicos que nos auxiliam na melhoria da sua experiência, tais como:</p>
        <ul>
          <li>Endereço IP e identificadores únicos do dispositivo;</li>
          <li>Tipo e versão do navegador utilizado;</li>
          <li>Dados sobre a conexão e uso do site, como tempo de permanência, páginas visitadas e interações realizadas;</li>
          <li>Informações sobre cookies e tecnologias semelhantes que registram suas preferências e ajudam na personalização dos conteúdos exibidos;</li>
          <li>Outros dados técnicos que possam ser relevantes para a segurança e a otimização dos nossos serviços.</li>
        </ul>
      </article>

      <article>
        <h3>4. Como Utilizamos e Tratamos os Dados Coletados</h3>
        <p>Cada informação que você compartilha conosco é utilizada com o propósito de oferecer um serviço personalizado, seguro e eficiente. De forma detalhada, as nossas práticas de tratamento de dados englobam os seguintes aspectos:</p>
        
        <h4>4.1. Avaliação e Personalização do Atendimento</h4>
        <p>Os dados coletados através do seu cadastro e do questionário de saúde são processados para construir o seu perfil individual, permitindo que a Puríssima realize uma análise criteriosa e recomende os suplementos que melhor se adequem às suas necessidades. Esse processo de personalização envolve a integração das informações fornecidas com os conhecimentos técnicos dos nossos profissionais.</p>
        
        <h4>4.2. Processamento, Manipulação e Entrega dos Produtos</h4>
        <p>Uma vez realizado o pedido, os seus dados são utilizados para viabilizar a manipulação dos suplementos na farmácia, garantir a precisão na produção e assegurar que os produtos sejam entregues com a máxima eficiência e segurança.</p>
        
        <h4>4.3. Comunicação e Acompanhamento Contínuo</h4>
        <p>Manter um canal aberto e transparente com você é fundamental para a Puríssima. Por isso, utilizamos os seus dados de contato para enviar notificações, mensagens de suporte, atualizações sobre o seu pedido e para acompanhar o seu tratamento por meio de comunicações via WhatsApp e e-mail. Essa interação contínua garante que você se sinta sempre amparado e informado sobre cada etapa do processo.</p>
        
        <h4>4.4. Marketing, Pesquisa de Satisfação e Aperfeiçoamento dos Serviços</h4>
        <p>Com o seu consentimento, os seus dados podem ser utilizados para enviar conteúdos informativos, novidades, promoções e campanhas de marketing. Além disso, realizamos pesquisas de satisfação que nos auxiliam a entender a sua experiência e identificar oportunidades de melhoria. O objetivo é manter um relacionamento transparente e contínuo, aprimorando os serviços oferecidos e contribuindo para o seu bem-estar.</p>
        
        <h4>4.5. Cumprimento de Obrigações Legais e Regulatórias</h4>
        <p>O tratamento dos seus dados também é realizado para que a Puríssima possa cumprir com as exigências legais e regulamentares aplicáveis, bem como para responder a eventuais solicitações de autoridades competentes, sempre respeitando os limites estabelecidos pela legislação de proteção de dados.</p>
      </article>

      <article>
        <h3>5. Compartilhamento e Transferência de Informações</h3>
        <p>A Puríssima valoriza a sua privacidade e, por isso, compartilha seus dados pessoais apenas em situações estritamente necessárias e de acordo com as finalidades descritas nesta política. Abaixo, explicamos com detalhes as condições e os parceiros com os quais seus dados podem ser compartilhados:</p>

        <h4>5.1. Compartilhamento com Fornecedores</h4>
        <p>Para viabilizar o atendimento e a entrega dos suplementos personalizados, seus dados poderão ser compartilhados com:</p>
        <ul>
          <li><strong>Laboratório de Manipulação Puríssima:</strong> Para que seja possível a manipulação dos produtos de acordo com as especificações do seu perfil de saúde;</li>
          <li><strong>Empresas de Logística e Entrega:</strong> Caso necessário, seus dados poderão ser repassados para parceiros responsáveis pela entrega dos produtos, garantindo que o serviço seja realizado de forma eficiente e segura.</li>
        </ul>

        <h4>5.2. Compartilhamento para Cumprimento de Obrigações Legais</h4>
        <p>Em situações onde a legislação ou autoridades judiciais e regulatórias assim o exijam, a Puríssima poderá compartilhar seus dados pessoais. Tais situações incluem, mas não se limitam a:</p>
        <ul>
          <li>Respostas a investigações legais;</li>
          <li>Cumprimento de ordens judiciais;</li>
          <li>Colaboração com órgãos de fiscalização e controle.</li>
        </ul>

        <h4>5.3. Transferência Internacional de Dados</h4>
        <p>Embora a Puríssima adote servidores de alta segurança, alguns dos dados coletados podem ser armazenados em infraestruturas de terceiros localizadas fora do território nacional. Essa transferência internacional é realizada de forma a garantir a proteção e a confidencialidade das informações, seguindo rigorosos padrões de segurança e em conformidade com a legislação vigente.</p>
      </article>

      <article>
        <h3>6. Armazenamento, Segurança e Medidas de Proteção</h3>
        <p>A segurança dos seus dados é uma prioridade para a Puríssima, e adotamos medidas técnicas, administrativas e organizacionais para proteger as informações contra acessos não autorizados, perda, alteração ou divulgação indevida. A seguir, detalhamos nossas práticas de armazenamento e segurança:</p>
        
        <h4>6.1. Armazenamento dos Dados</h4>
        <p>Os dados pessoais e sensíveis fornecidos por você são armazenados em servidores seguros, hospedados por provedores de alta confiabilidade, como os oferecidos pela AWS (Amazon Web Services). Esse ambiente de armazenamento é constantemente monitorado e atualizado para garantir a integridade das informações.</p>
        
        <h4>6.2. Medidas Técnicas de Segurança</h4>
        <p>Implementamos uma série de medidas técnicas para proteger seus dados, incluindo:</p>
        <ul>
          <li>Criptografia de dados durante a transmissão e armazenamento;</li>
          <li>Utilização de firewalls e sistemas de detecção de intrusões para monitorar acessos;</li>
          <li>Atualizações regulares de software e sistemas para corrigir vulnerabilidades;</li>
          <li>Detalhamento dos protocolos específicos de segurança que podem ser informados mediante solicitação.</li>
        </ul>

        <h4>6.3. Medidas Administrativas e Organizacionais</h4>
        <p>Além das medidas técnicas, a Puríssima adota procedimentos internos rigorosos, que incluem:</p>
        <ul>
          <li>Acesso restrito às informações apenas por profissionais autorizados e qualificados;</li>
          <li>Políticas internas de controle e auditoria para assegurar a conformidade com a legislação de proteção de dados.</li>
        </ul>

        <h4>6.4. Monitoramento e Prevenção de Incidentes</h4>
        <p>Realizamos monitoramento contínuo dos sistemas e implementamos mecanismos para detectar e prevenir eventuais incidentes de segurança. Caso seja identificado qualquer risco ou incidente, adotamos medidas imediatas para mitigar os efeitos e informar os usuários afetados, quando necessário.</p>
      </article>

      <article>
        <h3>7. Uso de Cookies e Tecnologias Similares</h3>
        <p>Para melhorar a sua experiência de navegação e oferecer conteúdos personalizados, a Puríssima utiliza cookies e outras tecnologias semelhantes. A seguir, explicamos como essas ferramentas funcionam e como você pode gerenciar suas preferências:</p>
        
        <h4>7.1. Finalidade dos Cookies</h4>
        <p>Os cookies são utilizados para:</p>
        <ul>
          <li>Registrar informações sobre a sua navegação no site, como páginas visitadas e preferências de acesso;</li>
          <li>Facilitar a autenticação e a personalização do conteúdo exibido, de acordo com os seus interesses;</li>
          <li>Monitorar o desempenho do site e coletar dados estatísticos que auxiliem na melhoria dos nossos serviços.</li>
        </ul>

        <h4>7.2. Controle e Configuração dos Cookies</h4>
        <p>Você pode, a qualquer momento, configurar seu navegador para recusar o uso de cookies ou para ser notificado quando um cookie estiver sendo enviado. No entanto, é importante destacar que a desativação dos cookies pode comprometer algumas funcionalidades e a personalização do site.</p>
      </article>

      <article>
        <h3>8. Direitos dos Titulares e Exercício de Controle</h3>
        <p>A Puríssima respeita e assegura os direitos dos titulares de dados pessoais, conforme estabelecido na legislação aplicável, especialmente na Lei Geral de Proteção de Dados (LGPD). Você tem o direito de:</p>
        
        <h4>8.1. Solicitar o Acesso aos Seus Dados</h4>
        <p>Você pode solicitar a confirmação da existência de tratamento de seus dados pessoais, bem como acessar as informações que mantemos sobre você.</p>
        
        <h4>8.2. Corrigir Dados Incompletos ou Incorretos</h4>
        <p>Caso identifique qualquer inconsistência ou desatualização em seus dados, você tem o direito de solicitar a sua correção ou atualização.</p>

        <h4>8.3. Solicitar a Exclusão de Seus Dados</h4>
        <p>Em situações em que os dados não forem mais necessários para as finalidades para as quais foram coletados ou em caso de revogação do consentimento, você pode solicitar a exclusão dos seus dados pessoais, ressalvadas as hipóteses legais que autorizem a manutenção.</p>

        <h4>8.4. Revogar o Consentimento</h4>
        <p>Você pode, a qualquer momento, revogar o seu consentimento para o tratamento dos seus dados pessoais, sem que isso comprometa a legalidade do tratamento realizado anteriormente.</p>

        <h4>8.5. Solicitar a Portabilidade dos Dados</h4>
        <p>Caso deseje, você tem o direito de solicitar a transferência dos seus dados para outro fornecedor de serviços ou produtos.</p>

        <h4>8.6. Exercício dos Direitos</h4>
        <p>Para exercer qualquer um dos direitos acima mencionados ou para obter esclarecimentos adicionais sobre o tratamento dos seus dados, entre em contato conosco através dos seguintes canais:</p>
        <ul>
          <li><strong>E-mail:</strong> contato@purissima.com</li>
        </ul>
        <p>Observação: Poderão ser solicitados documentos ou informações adicionais para confirmar a sua identidade e viabilizar o atendimento do seu pedido.</p>
      </article>

      <article>
        <h3>9. Alterações e Atualizações Desta Política</h3>
        <p>A Puríssima reserva-se o direito de atualizar ou modificar esta Política de Privacidade a qualquer momento, de acordo com a evolução dos nossos serviços, mudanças legislativas ou melhorias nos nossos processos. Em caso de alterações significativas, tomaremos as seguintes medidas:</p>
        <ul>
          <li>Publicação de uma versão atualizada desta política em nosso site;</li>
          <li>Notificação aos usuários por meio de e-mail ou WhatsApp, conforme apropriado;</li>
          <li>Disponibilização da versão anterior, se solicitada, para fins de consulta.</li>
        </ul>
        <p>Recomendamos que você verifique periodicamente esta página para se manter informado sobre quaisquer atualizações.</p>
      </article>

      <article>
        <h3>10. Contato, Suporte e Canais de Comunicação</h3>
        <p>A Puríssima valoriza o diálogo e a transparência com você. Se tiver dúvidas, sugestões ou precisar de esclarecimentos sobre qualquer aspecto desta Política de Privacidade ou sobre o tratamento dos seus dados, nossa equipe de suporte está à disposição para atendê-lo. Você pode entrar em contato pelos seguintes canais:</p>
        <ul>
          <li><strong>Site:</strong> chat online</li>
          <li><strong>E-mail:</strong> contato@purissima.com</li>
          <li><strong>WhatsApp:</strong> 11 5283-6305</li>
        </ul>
        <p>Nossa equipe está comprometida em responder a todas as solicitações e garantir que seus direitos sejam respeitados de forma ágil e eficiente.</p>
      </article>

      <article>
        <h3>11. Disposições Finais</h3>
        <p>Ao utilizar os serviços da Puríssima, preencher nossos questionários de saúde e fornecer seus dados pessoais, você concorda com esta Política de Privacidade.</p>
        <p>Esta política reflete o compromisso da Puríssima com a privacidade, segurança e transparência no tratamento de dados.</p>
        <p>Agradecemos por confiar na Puríssima para cuidar da sua saúde e bem-estar.</p>
      </article>
    </>
  );
};

export default PrivacyContent;
